import React, { useState, createRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ButtonField, Modal, ModalHeader, ModalBody, Iconsvg, WizardStepthrough, Stepthrough, StepItem, ButtonFieldIcon, Tooltip, TooltipBody } from '@wk/components-react16';
import { Toast } from '../../../services';
import { API_URL } from '../../../config/constants';
import HttpService from "../../../config/http.service";
import PromptUserDefined from './PromptUserDefined';
import AddEditPrompt from './AddEditPrompt';
import TryNowPrompt from './TryNowPrompt';
import ResponseTab from '../ResponseTab';
import ConfirmPromptScore from './ConfirmPromptScore';
import ImprovePromptScore from './ImprovePromptScore';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../store';
import { showLoading, hideLoading } from "../../../store/authReducer";
import { idText } from 'typescript';
import { isValidJSON } from '../../../utils';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import moment from 'moment';
import { Privilege } from '../../../config/constants/privilege';

const PromptStudio = ({ data }: any) => {
	const { isOpenPromptStudio, setIsOpenPromptStudio, prompt, setPrompt, setIsLoad, promptObj, userDefinedPromptType, setUserDefinedPromptType, isOpenImproveScore, setIsOpenImproveScore } = data;
	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();
	 const { authUser, authProject } = useSelector((state: RootState) => state.auth);
	const [fileList, setFileList] = useState([] as any);
	const [activeIndex, setActiveIndex] = useState(0);
	const [runPromptResponse, setRunPromptResponse] = useState([] as any);
	const [inputOfRunPromptResponse, setInputOfRunPromptResponse] = useState({} as any);
	const [documentText, setDocumentText] = useState('');
	const [documentUrl, setDocumentUrl] = useState('');
	const [promptTypeList, setPromptTypeList] = useState([] as any);
	const [taxonomyTree, setTaxonomyTree] = useState([] as any);
	const [guidedPromptPayload, setGuidedPromptPayload] = useState([] as any);
	const [initialStateGuidedPromptQuestion, setInitialStateGuidedPromptQuestion] = useState([]	as any);
	const [selectedIndex, setSelectedIndex] = useState(0);
	const [creatPromptType, setCreatPromptType] = useState(false);
	const [isOpenConfirmScore, setIsOpenConfirmScore] = useState(false);
	const [isOpenConfirmScoreQuestion, setIsOpenConfirmScoreQuestion] = useState(false);
	const [promptCategoryScore, setPromptCategoryScore] = useState([] as any);
	const [isScoreShow, setIsScoreShow] = useState(false);
	const [previousPrompt, setPreviousPrompt] = useState('');
	const [selectedTestAgent, setSelectedTestAgent] = useState('');
	const isValidInputTrynow = (text: any) => {
		if (!text || !text.trim()) {
			Toast('Please enter document text', "error");
			return false;
		}
		return true;
	}


	const isValidUrl = (url: string) => {
        try {
            const urlPattern = /^(https?:\/\/)([\w\d\-]+\.)+[\w\d\-]+(\/[^\s]*)?$/i;
            return urlPattern.test(url);
        } catch (error) {
            return false;
        }
    }

	const handleTryNow = async () => {
		if (!isValidInput(prompt)) return;
		if (await validateTaxonomy(taxonomyTree)) return;
		if (selectedIndex == 0) {
			if (!isValidInputTrynow(documentText)) return;
		}
		if (selectedIndex == 1) {
			if (fileList.length == 0) {
				Toast('Please upload document', "error");
				return;
			}
		}
		if (selectedIndex == 2) {
			if (!documentUrl || !documentUrl.trim()) {
				Toast('Please enter document url', "error");
				return false;
			}
			if (documentUrl.indexOf(' ') >= 0) {
				Toast('Document url should not contain spaces', "error");
				return false;
			}

			if (!isValidUrl(documentUrl)) {
				Toast('Please enter a valid URL', "error");
				return false;
			}

		}
		const formData = new FormData();
		formData.append('type', prompt.promptType?.code);
		formData.append('prompt', prompt.text);
		formData.append('outputType', prompt.jsonOutput);
		formData.append('documentText', documentText);
		formData.append('documentUrl', documentUrl);
		formData.append('fab_agent', selectedTestAgent ?  selectedTestAgent : prompt.promptType?.gptAgent || null);
		formData.append('projectId', authProject?.id);
		// Capture input data for export
		const inputData: any = {
			type: prompt.promptType?.code,
			prompt: prompt.text,
			outputType: prompt.jsonOutput,
			documentText: documentText,
			documentUrl: documentUrl
		};
		
		if (fileList.length > 0) {
			const fileNames = [];
			for (let file of fileList) {
				formData.append('document', file.nativeFile);
				fileNames.push(file.nativeFile.name);
			}
			inputData.documents = fileNames;
		}
		
		setInputOfRunPromptResponse(inputData);
		dispatch(showLoading());

		HttpService.postRequestFormData(API_URL.RUN_DOCUMENT, formData).then(
			(res: any) => {
				if (res.data && res.data[0]?.status == 'success') {
					setRunPromptResponse(res.data ?	res.data : []);
				} else {
                    setRunPromptResponse([{
                        documentName: "",
                        response: "",
                        rationale: "",
                        prompt_score: 0
                    }]);
                }
				dispatch(hideLoading());
			},
			(err: any) => {
				Toast(err.message, "error");
				dispatch(hideLoading());
			}
		)
	}

	const isValidInput = (prompt: any) => {
		if (!prompt.name || !prompt.name.trim()) {
			Toast('Please enter prompt name', "error");
			return false;
		}
		if (!prompt.text || !prompt.text.trim()) {
			Toast('Please enter prompt text', "error");
			return false;
		}
		if (!prompt.promptType || !prompt.promptType.code || !prompt.promptType.code.trim()) {
			Toast('Please select prompt type', "error");
			return false;
		}
		if (!prompt.tags || prompt.tags.length == 0) {
			Toast('Please select taxonomy', "error");
			return false;
		}
		return true;
	}

	const getCheckedNodes = (node: any) => {
		let checkedItems: any = [];

		if (node.isChecked) {
			checkedItems.push({
				id: node.id,
				name: node.name,
			});
		}

		if (node.children && node.children.length > 0) {
			node.children.forEach((child: any) => {
				checkedItems = checkedItems.concat(getCheckedNodes(child));
			});
		}
		return checkedItems;
	};

	const checkTopLevelSelections = (nodes: any) => {
		return nodes.map((category: any) => {
			let checkedItems: any = [];

			category.children.forEach((child: any) => {
				checkedItems = checkedItems.concat(getCheckedNodes(child));
			});

			return {
				category: category.name,
				hasChecked: checkedItems.length > 0,
				checkedItems
			};
		});
	};

	const getValidatePrompt = async (tree: any) => {
		const result: any = checkTopLevelSelections(tree).filter((item: any) => item.hasChecked);
		const payload: any = {
			projectId: authProject?.id,
			promptId: prompt.id ? prompt.id : null,
			promptTypeCode: prompt?.promptType?.code,
			catCodesMap: {}
		};
		result.forEach((item: any) => {
			if (item.hasChecked) {
				payload.catCodesMap[item.category] = item.checkedItems.map((checkedItem: any) => checkedItem.id);
			}
		});
		if (result.length > 0) {
			try {
				const res = await HttpService.postRequest(`${API_URL.VALIDATE_PROMPT}`, payload);
				return res;
			} catch (err: any) {
				return err.message;
			}
		}
	}

	const validateTaxonomy = async (tree: any) => {
		const result = checkTopLevelSelections(tree);
		let stg = result.filter((item: any) => !item.hasChecked).map((item: any) => item.category).join(', ');
		if (stg.length > 0) {
			Toast(`At least one leaf node must be selected from each category: ${stg}`, "error");
			return true;
		} else {
			const res: any = await getValidatePrompt(taxonomyTree);
			if (res && res.message) {
				Toast(res.message, "error");
				return true;
			}
		}
		return false;
	};

	const handlePromptScore = async (status: boolean) => {
		if (!isValidInput(prompt)) return;
		if (status) {
			if (await validateTaxonomy(taxonomyTree)) return;
		}

		//onNext();
		if (previousPrompt.trim() == prompt.text.trim()){
			if (!status) {
				setIsOpenConfirmScore(true);
			}
			setIsScoreShow(true);
			if (status && activeIndex < 1) {
				onNext();
			}
		} else {
			getPromptScore(status);
		}
	}

	const getPromptScore = (status: boolean) => {
		if (!prompt.text || !prompt.text.trim()) {
			Toast('Please enter prompt text', "error");
			return;
		}
		if (!prompt.promptType || !prompt.promptType.code || !prompt.promptType.code.trim()) {
			Toast('Please select prompt type', "error");
			return;
		}
		if(!promptCategoryScore || promptCategoryScore.length == 0) {
			Toast('Category score types are not defined for this project. Please contact administrator.', "error");
			return;
		}
		dispatch(showLoading());
		const payload: any = {
			promptType: prompt.promptType.code,
			promptInstructions: prompt.text,
			categoryScore: promptCategoryScore
		}
		HttpService.postRequest(API_URL.IMPROVED_PROMPT_SCORE, payload).then(
			(res: any) => {
				if (res.data){

					setPrompt({
						...prompt,
						score: res.data.totalScore
					});
					if (!status) {
						setIsOpenConfirmScore(true);
					}
					setIsScoreShow(true);
					setPreviousPrompt(prompt.text);
					setPromptCategoryScore(res.data.categoryScore);
				} else {
					setIsScoreShow(true);
					setPrompt({
						...prompt,
						score: 0
					});
					Toast('There is an error occurred for getting prompt score, please try again.', "error");
				}
				dispatch(hideLoading());
				if (status && activeIndex < 1) {
					onNext();
				}
			},
			(err: any) => {
				Toast(err.message, "error");
				setIsScoreShow(true);
				setPrompt({
					...prompt,
					score: 0
				});
				dispatch(hideLoading());
				if (status && activeIndex < 1) {
					onNext();
				}
			}
		)
	}

	const improveScore = () => {
		setIsOpenConfirmScoreQuestion(true);
		setRunPromptResponse([]);
	}

	const savePrompt = async (ispublish: boolean =  false) => {
		if (!isValidInput(prompt)) return;
		dispatch(showLoading());
		if (await validateTaxonomy(taxonomyTree)) {
			dispatch(hideLoading());
			return;
		}
		let catCodesMap: any = {}
		const result: any = checkTopLevelSelections(taxonomyTree).filter((item: any) => item.hasChecked);
		result.forEach((item: any) => {
			if (item.hasChecked) {
				catCodesMap[item.category] = item.checkedItems.map((checkedItem: any) => checkedItem.id);
			}
		});

		const payload: any = {
			projectId: authProject.id,
			id: prompt.id,
			promptTypeId: prompt.promptType.id,
			promptTypeCode: prompt.promptType.code,
			taxonomyIds: prompt?.tags?.map((item: any) => item.id),
			name: prompt.name,
			text: prompt.text,
			jsonOutput: prompt.jsonOutput,
			score: prompt.score,
			categoryScore: promptCategoryScore,
			catCodesMap: catCodesMap,
		}
		
		HttpService.postRequest(API_URL.ADD_PROMPT, payload).then(
			(res: any) => {
				if(ispublish) {
					publishPrompt(res.id);
				} else {
					Toast(prompt.id > 0 ? 'Prompt updated successfully.' : 'Prompt added successfully.', "success");
					resetForm();
					if (location.pathname != '/prompt') navigate("/prompt");
					setTimeout(() => {
						dispatch(hideLoading());
						setIsLoad(true);
					}, 500);
				}
			},
			(err: any) => {
				Toast(err.message, "error");
				dispatch(hideLoading());
			}
		)
	}

	const publishPrompt = async (promptId: number) => {
		HttpService.postRequest(API_URL.PUBLISH_PROMPT, {promptId: promptId || prompt.id}).then(
			(res: any) => {
				Toast('Prompt published successfully.', "success");
				resetForm();
				if (location.pathname != '/prompt') navigate("/prompt");
				setTimeout(() => {
					dispatch(hideLoading());
					setIsLoad(true);
				}, 500);
			},
			(err: any) => {
				Toast(err.message, "error");
				dispatch(hideLoading());
			}
		)
	}

	const onNext = () => {
		setActiveIndex(activeIndex + 1);
	}

	const onPrevious = () => {
		if (activeIndex === 0) {
			if (!creatPromptType){
				resetForm();
			}
			if (userDefinedPromptType) {
				setCreatPromptType(false);
			}
		} else {
			setActiveIndex(activeIndex - 1);
		}
	}

	const resetForm = () => {
		setIsOpenPromptStudio(false);
		setUserDefinedPromptType(false);
		setGuidedPromptPayload(initialStateGuidedPromptQuestion);
		setPrompt(promptObj);
		setDocumentText('');
		setFileList([]);
		setRunPromptResponse([]);
		setInputOfRunPromptResponse({});
		setIsOpenConfirmScore(false);
		setIsOpenConfirmScoreQuestion(false);
		setPromptCategoryScore([]);
		setIsOpenImproveScore(false);
		setIsScoreShow(false);
	}

	const getCategoryScoreType = () => {
		HttpService.getRequest(`${API_URL.GET_CATEGORY_SCORE_TYPE_BY_PROJECT_ID_APPLICABLE}/${authProject.id}`).then(
			(res: any) => {
				const list = res.map((item: any) => ({ id: null, categoryScoreTypeId: item.id, categoryScoreTypeCode: item.code, categoryScoreTypeName: item.name, categoryScoreTypeDescription: item.description, partialPrompt: '', rationale: '', suggestion: '', score: 0 }));

				const updatedList = list.map((item: any) => {
					const matchedItem = prompt.categoryScore?.find((itm: any) => itm.categoryScoreTypeCode === item.categoryScoreTypeCode);
					if (matchedItem) {
						return {
							...item,
							partialPrompt: matchedItem.partialPrompt,
							rationale: matchedItem.rationale,
							suggestion: matchedItem.suggestion,
							score: matchedItem.score
						};
					}
					return item;
				});
				setPromptCategoryScore(updatedList);
			},
			(err: any) => {
				Toast(err.message, "error")
			},
		)
	}

	const getGuidedPromptQuestion = () => {
		HttpService.getRequest(`${API_URL.GET_GUIDED_PROMPT_QUESTION}/${authProject.id}`).then(
			(res: any) => {
				const list: any = res.sort((a: any, b: any) => a.id - b.id).map((item: any) => ({ question: item.question, example: item.example, answer: '' }));
				setInitialStateGuidedPromptQuestion(list);
				setGuidedPromptPayload(list);
			},
			(err: any) => {
			},
		)
	}

	const getPromptType = () => {
		HttpService.getRequest(`${API_URL.GET_PROMPT_TYPE_BY_PROJECT_ID_APPLICABLE}/${authProject.id}`).then(
			(res: any) => {
				setPromptTypeList(res);
			},
			(err: any) => {
				Toast(err.message, "error");
			},
		)
	}

	const getTaxonomyTreeByProject = () => {
		HttpService.getRequest(`${API_URL.GET_TAXONOMY_TREE_BY_PROJECT_ID}/${authProject.id}`).then(
			(res: any) => {
				const ids = prompt.tags.length > 0 ? prompt.tags.map((item: any) => item.id) : [];
				setTaxonomyTree(addIsCheckedKey(res, ids));
			},
			(err: any) => {
				Toast(err.message, "error");
			},
		)
	}

	const addIsCheckedKeyInTree = (tree: any, selectedItem: any) => {
		return tree.map((item: any) => {
			const isChecked = selectedItem?.some((itm: any) => itm == item.id)
			if (item.children && item.children.length > 0) {
				return {
					...item,
					isChecked: isChecked,
					children: addIsCheckedKeyInTree(item.children, selectedItem),
				};
			}

			return {
				...item,
				isChecked: isChecked
			};
		});
	};

	const addIsCheckedKey = (tree: any, selectedItem: any) => {
		return tree.map((item: any) => {
			if (item.children && item.children.length > 0) {
				return {
					...item,
					children: addIsCheckedKeyInTree(item.children, selectedItem)
				};
			}
		});
	};

	const exportPromptOutput = () => {
		if (runPromptResponse?.data?.length == 0) {
			Toast('No prompt output available to export', "error");
			return;
		}
		
		const exportData = {
			input: inputOfRunPromptResponse,
			output: runPromptResponse
		};
		
		const jsonString = JSON.stringify(exportData, null, 2);
		const blob = new Blob([jsonString], { type: 'application/json' });
		const url = window.URL.createObjectURL(blob);
		const link = document.createElement('a');
		link.href = url;
		link.download = `Prompt_Output_${new Date().toISOString().replace(/[:.]/g, '-')}.json`;
		document.body.appendChild(link);
		link.click();
		
		// Cleanup
		document.body.removeChild(link);
		window.URL.revokeObjectURL(url);
		
		Toast('Prompt output exported successfully', 'success');
	}

	const exportPromptOutputExcel = () => {
		if(isValidJSON(runPromptResponse[0].response)) {
			let responseData = JSON.parse(runPromptResponse[0].response);

			if(prompt.promptType.name == 'Requirement Authoring') {
				responseData = responseData.requirements;
				if (!responseData) {
					Toast('No prompt output available to export', "error");
					return;
				}
				//flatten the response data for Excel export
				const flattenedData = responseData.map((item: any) => ({
					...item,
					subthemeTitle: item.subtheme?.title,
					subthemeSummary: item.subtheme?.summary,
					subthemeRationale: item.subtheme?.rationale
				}));
	
				flattenedData.forEach((item: any) => delete item.subtheme); // removed flattened object to avoid confusion in excel
				exportToExcel(flattenedData);
			} else if (prompt.promptType.name == 'Requirement Clustering') {
				responseData = responseData.clusters;
				if (!responseData) {
					Toast('No prompt output available to export', "error");
					return;
				}
				//flatten the response data for Excel export
				const flattenedData = responseData.flatMap((cluster:any) =>
					cluster.requirements.map((req:any) => ({
						id: cluster.id,
						name: cluster.name,
						summary: cluster.summary,
						rationale: cluster.rationale,
						requirementId: req.id,
						requirementTitle: req.title,
						status: cluster.status
					}))
				);
	
				flattenedData.forEach((item: any) => delete item.requirements); // removed flattened object to avoid confusion in excel
				exportToExcel(flattenedData);
			} else if (prompt.promptType.name == 'Tagging') {
				responseData = responseData.tags;
				if (!responseData) {
					Toast('No prompt output available to export', "error");
					return;
				}

				exportToExcel(responseData);

			}


		} else {
			Toast('Prompt output is not in valid JSON format, cannot export to Excel', "error");
			return;
		}
	}

	const exportToExcel = (jsonData:any) => {
		const worksheet = XLSX.utils.json_to_sheet(jsonData);

		const workbook = {
			Sheets: { data: worksheet },
			SheetNames: ["data"]
		};

		const excelBuffer = XLSX.write(workbook, {
			bookType: "xlsx",
			type: "array"
		});

		const fileData = new Blob([excelBuffer], {
			type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
		});

		saveAs(fileData, "Prompt_Output.xlsx");
	};

	const clearDraft = () => {
		dispatch(showLoading());
		HttpService.getRequest(`${API_URL.GET_PUBLISHED_PROMPT_BY_ID}/${prompt.id}`).then(
			(res: any) => {
				setPrompt(res);
				Toast('Draft cleared. Reverted to last published version.', "success");
				dispatch(hideLoading());
			},
			(err: any) => {
				Toast(err.message, "error");
				dispatch(hideLoading());
			}
		)	
	}

	useEffect(() => {
		if (authProject && authProject.id) {
			getGuidedPromptQuestion();
			getTaxonomyTreeByProject();
			getPromptType();
			getCategoryScoreType();
		}
	}, [authProject]);

	useEffect(() => {
		if (isOpenImproveScore) {
			if (prompt.categoryScore) {
				setPreviousPrompt(prompt.text);
				setPromptCategoryScore(prompt.categoryScore);
				setIsOpenConfirmScore(true);
				setIsScoreShow(true);
			} else {
				getPromptScore(false);
			}
			setIsOpenImproveScore(false);
		}
	}, [isOpenImproveScore, prompt]);

	return (
		<div className="custom-wizard" style={{ height: '100%' }}>
			<Modal
				mobileMode="fullscreen"
				isFullscreen
				isOpen={isOpenPromptStudio}
				srLabelledBy={'modal-id-001'}
				srDescribedBy={'modal-id-002'}
				width={'98%'}
				height={'98%'}
				onUserRequest={() => resetForm()}>
				<ModalHeader
					isFullscreenButtonVisible
					titleId={'modal-id-001'}
					descriptionId={'modal-id-002'}
					hasBorderBottomMobile>
					Prompt Workflow
					<WizardStepthrough>
						<div slot="default" className='mt-5 mb-5'>
							<Stepthrough
								mode='normal'
								activeIndex={activeIndex}
								stepIcons={[
									'artificial-intelligence',
									'filled-save'
								]}>
								<StepItem slot="stepItem">Try GenAI</StepItem>
								<StepItem slot="stepItem">Save</StepItem>
							</Stepthrough>
						</div>
					</WizardStepthrough>
				</ModalHeader>
				<ModalBody>
					<div className={`${(runPromptResponse.length > 0 && activeIndex != 2) ? 'mt-15' : 'card-maxwidth mt-15'}`}>
						<ButtonField iconPosition={'left'} mode={'ghost'} size={'small'}>
							<button
								type="button"
								data-e2e="cg-previous-button"
								onClick={onPrevious}>
								<Iconsvg name="arrow-left"></Iconsvg>
								Back{' '}
							</button>
						</ButtonField>
					</div>
					{activeIndex === 0 ? (
						<>
							{userDefinedPromptType && !creatPromptType ? (
								<PromptUserDefined data={{ guidedPromptPayload, setGuidedPromptPayload, prompt, setPrompt, creatPromptType, setCreatPromptType, promptTypeList }} />
							) : null}
							{(!userDefinedPromptType || creatPromptType) ? <div className="wk-row ml-0 mr-0">
								<div className={`fade-in ${runPromptResponse.length > 0 ? 'wk-col-4 pl-0' : 'card-maxwidth card-primary pl-15 pb-15 mb-20'}`}>
								{(prompt.status == 'DRAFT'&& prompt.version != 1) ? 
									<div  className='p-15 pt-15 pb-0 text-right'>
										<span id='draft'>
											<Iconsvg name="customer-template" color='#0c5460ff'></Iconsvg>
												<Tooltip
													targetSelector="#draft"
													identifier="tooltip-bottom"
													position="bottom"
													>
													<TooltipBody slot="tooltipBody">Last draft edited by: {prompt.updatedBy} | {moment(prompt.updated).utc().format('MM-DD-YYYY HH:mm:ss [UTC]')}</TooltipBody>
												</Tooltip>
										</span>
										<span className='link cursor ml-10' onClick={() => clearDraft()}>Clear Draft</span>
									</div>
								: null}
									<div className="pr-15 pt-15 custom-fs-field">
										<AddEditPrompt data={{ prompt, setPrompt, handlePromptScore, isScoreShow, promptTypeList, promptCategoryScore, taxonomyTree, setTaxonomyTree, validateTaxonomy, selectedTestAgent, setSelectedTestAgent }} />
										<TryNowPrompt data={{ selectedIndex, setSelectedIndex, documentText, setDocumentText, fileList, setFileList, documentUrl, setDocumentUrl }} />
										<div className='text-right'>
											{isScoreShow ? <ButtonField iconPosition={'right'} mode={'ghost'}>
												<button type="button"
													onClick={() => improveScore()} className='mr-10'>
													Enhance Score
												</button>
											</ButtonField> : null}
											{authUser?.privileges.includes(Privilege[Privilege.PUBLISH_PROMPT]) && 
												<ButtonField iconPosition={'right'} mode={'ghost'}>
													<button type="button"
														onClick={() => savePrompt(true)} className='mr-10'>
														Publish Prompt
													</button>
												</ButtonField>
											}
											<ButtonField iconPosition={'right'} mode={'ghost'}>
												<button type="button"
													onClick={() => savePrompt()} className='mr-10'>
													Save Prompt as Draft
												</button>
											</ButtonField>
											<ButtonField>
												<button type="button"
													onClick={() => handleTryNow()}>
													Try Prompt
												</button>
											</ButtonField>
										</div>
									</div>
								</div>
								{(activeIndex == 0 && runPromptResponse.length > 0) ? (
									<div className='wk-col-8 pr-0 border-start border-primary-subtle fade-in'>
										<div className="p-20 pr-0 pt-0">
											<div className="text-right">
											{(prompt.promptType.name == 'Requirement Authoring' || prompt.promptType.name == 'Requirement Clustering' || prompt.promptType.name == 'Tagging') ? (
											<>
												<ButtonFieldIcon>
													<button id='export-excel-output' type="button" onClick={() => exportPromptOutputExcel()}>
														<Iconsvg name="file-excel" color='#020102ff'></Iconsvg>
													</button>
												</ButtonFieldIcon>
												<Tooltip
													targetSelector="#export-excel-output"
													identifier="tooltip-top"
													position="top"
													>
													<TooltipBody slot="tooltipBody">Export Prompt Output Excel</TooltipBody>
												</Tooltip>
											</>
												
											) : null}
											 <ButtonFieldIcon>
												<button id='export-prompt-output' type="button" onClick={() => exportPromptOutput()}>
													<Iconsvg name="export" color='#020102ff'></Iconsvg>
												</button>
											</ButtonFieldIcon>
											</div>
											<Tooltip
												targetSelector="#export-prompt-output"
												identifier="tooltip-top"
												position="top"
												>
												<TooltipBody slot="tooltipBody">Export Prompt Output JSON</TooltipBody>
											</Tooltip>
											<ResponseTab data={{ runPromptResponse, setRunPromptResponse, validationResponse: {} }} />
										</div>
									</div>
								) : null}
							</div> : null}
						</>
					) : null}

					{activeIndex == 1 ? (
						<div className="p-15 card-maxwidth card-primary mb-20 fade-in custom-fs-field">
							<AddEditPrompt data={{ prompt, setPrompt, handlePromptScore, isScoreShow, promptTypeList, promptCategoryScore, taxonomyTree, setTaxonomyTree, validateTaxonomy, selectedTestAgent, setSelectedTestAgent }} />
							<div className='text-right'>
								<ButtonField>
									<button type="button"
										onClick={() => savePrompt()}>
										Submit
									</button>
								</ButtonField>
							</div>
						</div>
					) : null}
				</ModalBody>
			</Modal>
			{isOpenConfirmScore && <ConfirmPromptScore data={{ isOpenConfirmScore, setIsOpenConfirmScore, setIsOpenConfirmScoreQuestion, promptCategoryScore }} />}
			{isOpenConfirmScoreQuestion && <ImprovePromptScore data={{ isOpenConfirmScoreQuestion, setIsOpenConfirmScoreQuestion, promptCategoryScore, setPromptCategoryScore, prompt, setPrompt, onPrevious, activeIndex }} />}
		</div>
	);
};

export default PromptStudio;